<style lang="scss">
  @use "../../../assets/css/design-system/utils";

  .date-grid {
    display: flex;
    flex-direction: column;
    gap: utils.in_rem(4px);
    padding: 0 0 utils.in_rem(4px);
  }

  .date-grid-row {
    display: flex;
    width: 100%;
  }
</style>

<script>
  import DateItem from "../../atoms/DateItem.svelte";

  let { weeks = [], onDayClick = () => {}, isRange = true } = $props();
</script>

<div class="date-grid">
  {#each weeks as week}
    <div class="date-grid-row">
      {#each week as day}
        <DateItem {day} onclick={() => onDayClick(day)} {isRange} />
      {/each}
    </div>
  {/each}
</div>
